import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'
import Spinner from '../ui/spinner'
import { useState } from 'react'

interface OGEAvatarProps {
    src?: string | null
    fallback?: string
    variant?: 'sm' | 'md' | 'lg'
    isLoading: boolean
}

const OGEAvatar: React.FC<OGEAvatarProps> = ({
    src,
    fallback = '/images/avatar-image.svg',
    variant = 'md',
    isLoading = false,

}) => {
    const [isImageLoading, setIsImageLoading] = useState(true)

    const sizeClasses = {
        sm: 'h-8 w-8',
        md: 'h-10 w-10',
        lg: 'h-16 w-16',

    }

    return (
        <Avatar className={sizeClasses[variant]}>
            {isLoading ? (
                <Spinner />
            ) : (
                <>
                    <AvatarImage
                        src={src || '/images/avatar-image.svg'}
                        alt="Profile"
                        className="object-cover"
                        onLoad={() => setIsImageLoading(false)}
                        onError={() => setIsImageLoading(false)}
                    />
                    {isImageLoading && (
                        <AvatarFallback>
                            {fallback}
                        </AvatarFallback>
                    )}
                </>
            )}
        </Avatar>
    )
}

export default OGEAvatar